<template>
    <v-container fluid>
        <v-row style="padding-bottom: 20px;">
            <v-col
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                xl="2"
                lg="3"
                md="2"
                sm="2"
            >
                <h3>User Performance</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                cols="12"
                lg="3"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuStartDate"
                    v-model="mnuStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Start Date</label>
                        <v-text-field
                            v-model="filter.startDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.startDate"
                        no-title
                        @input="mnuStartDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col
                cols="12"
                lg="3"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuEndDate"
                    v-model="mnuEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>End Date</label>
                        <v-text-field
                            v-model="filter.endDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.endDate"
                        no-title
                        @input="mnuEndDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>
            <v-col
                cols="12"
                lg="2"
                md="3"
                sm="6"
            >
                <label>Profile</label>
                <v-combobox
                    v-model="filter.profileSelected"
                    :items="listProfiles"
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="filterUser(); filter.userSelected = null"
                ></v-combobox>
            </v-col>
            <v-col
                cols="12"
                lg="2"
                md="3"
                sm="6"
            >
                <label>User</label>
                <v-combobox
                    v-model="filter.userSelected"
                    :items="listUsers"
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>
            
            <v-col
                style="text-align: right; margin-top: 22px;"
                cols="12"
                lg="1"
                md="1"
                sm="8"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            @click="getRegisters"
                        >
                            Refresh
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="listUserPerformance"
                    :options.sync="options"
                    :loading="loading"
                    :items-per-page="10"
                    no-data-text="No Record Found"
                >
                    <template v-slot:item.qtd="{ item }">
                        <strong>{{ item.qtd }} </strong>
                    </template>

                    <template v-slot:item.valueFormatted="{ item }">
                        <strong>{{ item.valueFormatted }} </strong>
                    </template>

                    <template
                        v-slot:footer
                    >
                        <table cellspacing="10" style="width: 100%; border: none; margin: 15px;">
                            <tbody style="padding: 10px;">
                                <tr>
                                    <td style="width: 75%; font-size: 25px; font-weight: bold;">Total</td>
                                    <td>
                                        <v-chip dark>{{ totals.totalItems }}</v-chip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import * as moment from 'moment';

    export default ({

        mixins: [Helpers],

        data: () => ({

            loading: false,

            listUsers: [],
            listProfiles: [],

            filter: {
                profileSelected: null,
                userSelected: null,
                startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
                endDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
                startDateFormatted: moment().clone().startOf('month').format('MM/DD/YYYY'),
                endDateFormatted: moment().clone().endOf('month').format('MM/DD/YYYY')
            },

            headers: [
                { text: "User", value: "userName", width:"30%", sortable: true },
                { text: "Qty ToDo", value: "qtyToDo", width:"15%", sortable: true },
                { text: "Qty Jobs", value: "qtyJobs", width:"15%", sortable: true },
                { text: "Qty Work Orders", value: "qtyWorkOrders", width:"15%", sortable: true },
                { text: "Qty Customers", value: "qtyCustomers", width:"15%", sortable: true },
                { text: "Total Items", value: "totalItems", width:"10%", sortable: true }
            ],

            options: { rowsPerPage: 10, page: 1 },
            listUserPerformance: [],

            mnuStartDate: false,
            mnuEndDate: false
        }),

        watch: {
            "filter.startDate" () {
                this.filter.startDateFormatted = this.formatDate(this.filter.startDate)
                this.getRegisters();
            },

            "filter.endDate" () {
                this.filter.endDateFormatted = this.formatDate(this.filter.endDate)
                this.getRegisters();
            },
        },

        computed: {
            totals() {
                let totalItems = 0;

                if (this.listUserPerformance != null && this.listUserPerformance != undefined) {
                    this.listUserPerformance.forEach(item => {
                        totalItems += item.totalItems;
                    })
                }

                return {
                    totalItems
                }
            }
        },

        methods: {

            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },

            async filterUser () {

                this.showLoading();

                if (this.filter.profileSelected != null && this.filter.profileSelected != undefined) {
                    this.filter.idProfile = this.filter.profileSelected.id;
                    this.listUsers = this.listUsersClone.filter(usr => usr.idProfile == this.filter.idProfile)
                } else {
                    this.listUsers = [...this.listUsersClone];
                }

                this.hideLoading();
            },

            async getLists() {
                this.listProfiles = await this.$store.dispatch("profileModule/List");
                this.listUsers = await this.$store.dispatch("userModule/List");
            },

            async getRegisters() {
                this.showLoading();
                this.listUserPerformance = await this.$store.dispatch("reportModule/UserPerformance", this.getFilterRequest());
                this.hideLoading();
            },

            getFilterRequest() {

                let idUser = 0;

                if (this.filter.userSelected != null && this.filter.userSelected != undefined) {
                    idUser = this.filter.userSelected.id;
                }

                const startDate = this.filter.startDate;
                const endDate = this.filter.endDate;

                const request = {
                    idUser,
                    startDate,
                    endDate
                }

                return request;
            }
        },

        async created() {
            await this.getLists();
            this.listUsersClone = [...this.listUsers];
            await this.getRegisters();
        }
    })
</script>